import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { MisFacturasPage } from "@/features/mis-facturas/components/MisFacturasPage";
import { MisFacturasSkeleton } from "@/features/mis-facturas/components/MisFacturasSkeleton";
import { misFacturasQueryOptions } from "@/features/mis-facturas/hooks/use-mis-facturas";
import { paramsInicialesMisFacturas } from "@/features/mis-facturas/utils/ordenar-facturas";
import { PAGE_SIZE } from "@/lib/hooks/use-server-pagination";

/**
 * Ruta `/facturas` · "Mis facturas" (P30): acuses de validación de los CFDIs
 * del solicitante actual. Loader precarga la primera página sin filtros (misma
 * queryKey que arma MisFacturasPage al montar).
 */
export const Route = createFileRoute("/_authed-tw/facturas")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.facturasVer])
      ? queryClient.ensureQueryData(misFacturasQueryOptions(paramsInicialesMisFacturas(PAGE_SIZE)))
      : undefined,
  // Mientras resuelve la precarga · la MISMA forma que la página (no el PageSkeleton genérico).
  pendingComponent: MisFacturasSkeleton,
  component: () => (
    <PermissionGate permisos={[PERMISOS.facturasVer]}>
      <MisFacturasPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
